module.exports = __webpack_public_path__ + "static/media/boomerangs.1d740f49.png";